import cartApi from '@/api/cart-api.js'

export default {
  state: {
    cartItems: [],
    cartInfo: {},
    companyDetails: {}
  },
  getters: {
    getCartItems (state) {
      return state.cartItems
    },
    getCartInfo (state) {
      return state.cartInfo
    },
    getCompanyDetails (state) {
      return state.companyDetails
    }
  },
  mutations: {
    setCartItems (state, value) {
      state.cartItems = value
    },
    setCartInfo (state, value) {
      state.cartInfo = value
    },
    setCompanyDetails (state, value) {
      state.companyDetails = value
    }
  },
  actions: {
    ADD_TO_CART ({ commit }, { body, success, fail }) {
      cartApi.addToCart(body).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success && resBody.errorCode === null) {
            commit('setCartItems', resBody.value.productItems)
            commit('setCartInfo', resBody?.value)
            if (body.checkout) {
              const value = resBody.value
              const companyDetails = {
                companyName: value.companyName,
                companyPicName: value.companyPicName,
                picPhoneNumber: value.picPhoneNumber,
                companyAddress: value.companyAddress,
                shippingAddress: value.shippingAddress,
                dealerId: value.dealerId,
                address: value.address || null,
                addressLabel: value.addressLabel || null,
                addressId: value.addressId || null
              }
              commit('setCompanyDetails', companyDetails)
            }
            if (typeof (success) === 'function') success(resBody)
          } else {
            commit('setCartInfo', {})
            if (typeof (fail) === 'function') fail(res)
          }
        },
        err => {
          commit('setCartInfo', {})
          if (typeof (fail) === 'function') fail(err)
        }
      )
    },
    GET_CART_ITEMS ({ commit }, { payload, success, fail } = {}) {
      cartApi.getCartItems(payload).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success && resBody.errorCode === null) {
            commit('setCartItems', resBody.value.productItems)
            commit('setCartInfo', resBody?.value)
            if (typeof (success) === 'function') success(resBody)
          } else {
            commit('setCartItems', [])
            commit('setCartInfo', {})
            if (typeof (fail) === 'function') fail(res)
          }
        },
        err => {
          commit('setCartInfo', {})
          if (typeof (fail) === 'function') fail(err)
        }
      )
    },
    CREATE_QUOTATION (_, { body = null, success, fail }) {
      cartApi.createQuotation(body).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success && resBody.errorCode === null) {
            success && success(resBody.value.quotationNumber)
          } else {
            fail && fail(res)
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },
    UPDATE_ADDRESS ({ commit }, { payload = null, success, fail }) {
      cartApi.addToCart(payload).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success && resBody.errorCode === null) {
            commit('setCartItems', resBody.value.productItems)
            commit('setCartInfo', resBody?.value)
            const value = resBody.value
            const companyDetails = {
              companyName: value.companyName,
              companyPicName: value.companyPicName,
              picPhoneNumber: value.picPhoneNumber,
              companyAddress: value.companyAddress,
              dealerId: value.dealerId,
              address: value.address,
              addressLabel: value.addressLabel,
              addressId: value.addressId,
              shippingAddress: value.shippingAddress
            }
            commit('setCompanyDetails', companyDetails)
            success && success(resBody)
          } else {
            this.cartInfo = {}
            fail && fail(res)
          }
        },
        err => {
          commit('setCartInfo', {})
          fail && fail(err)
        }
      )
    },
    GET_AVAILABLE_TERMS_OF_PAYMENT (_, { success, fail }) {
      cartApi.getAvailableTermsOfPayment().then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            const availableTermsOfPayments = resBody?.value?.availableTermsOfPayments || []
            success && success(availableTermsOfPayments)
          } else {
            this.availableTermsOfPayment = []
            fail && fail(res)
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },
    DOWNLOAD_DEALER_PURCHASE_REPORT (_, { payload, success, fail }) {
      cartApi.downloadDealerPurchaseReport(payload).then(
        res => {
          const resBody = res?.body
          if (resBody && resBody.success) {
            const base64XlsxData = resBody?.value.base64FileContent || null
            const fileName = resBody?.value?.fileName || null
            success && success(base64XlsxData, fileName)
          } else {
            fail && fail()
          }
        },
        err => {
          fail && fail(err)
        }
      )
    }
  },
  namespaced: true
}
